<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-06 19:46:38
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="达人昵称">
				<el-input v-model="formData['author_account']" placeholder="请输入达人昵称"></el-input>
			</el-form-item>
			<el-form-item :label="platformId | formatPlatformName('unify')">
				<el-input v-model="formData['author_short_id']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item v-if="viewValue === 2 ? isAllDataView : true">
				<el-dropdown @command="setValue" slot="label">
					<span class="el-dropdown-link">
						{{ value === 1 ? '搜部门' : '搜员工' }}
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in options" :key="item.value" :command="item.value">
							{{ item.label }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<deptTreeSelect returnArray v-model="formData['deptIds']" :collapseTags="true" size="small" ref="deptTreeSelect" v-if="value === 1" />
				<DrPartnerSelect ref="drSelect" v-model="talentUserIds" v-if="value === 2" :hasUnassigned="isAllDataScope" />
			</el-form-item>
			<el-form-item :label="zsRoleName" v-if="viewValue === 2 ? isAllDataView : true">
				<ZsPartnerSelect ref="zsSelect" v-model="bdUserIds" :hasUnassigned="isAllDataScope"></ZsPartnerSelect>
			</el-form-item>
			<el-form-item style="margin-left: 96px">
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { mapGetters } from 'vuex';
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
import DrPartnerSelect from '@/components/drPartnerSelect';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { drRoleType, zsRoleType } from '@/utils/dataMap';
export default {
	name: 'search',
	props: {
		platformId: {
			type: [String, Number],
			default: '1',
		},
		viewValue: {
			type: [String, Number],
			default: '',
		},
	},
	components: {
		deptTreeSelect,
		DrPartnerSelect,
		ZsPartnerSelect,
	},
	data() {
		return {
			formData: {
				author_account: '',
				author_short_id: '',
				deptIds: [],
			},
			talentUserIds: '',
			bdUserIds: '',
			options: [
				{ label: '搜部门', value: 1 },
				{ label: '搜员工', value: 2 },
			],
			value: 1,
		};
	},
	computed: {
		...mapGetters([
			// 仅本人数据权限
			'isPersonDataScope',
			// 具有部门权限筛选//本部门
			'hasDeptDataScope',
			// 是否展示部门下拉筛选项//本部门及以下
			'showDeptSelect',
			// 全部数据权限
			'isAllDataScope',
			'isAllDataView',
		]),
		drRoleName() {
			return drRoleType.name;
		},
		zsRoleName() {
			return zsRoleType.name;
		},
	},

	methods: {
		setValue(value) {
			this.value = value;
			if (value === 1) {
				this.talentUserIds = '';
			} else {
				this.formData.deptIds = [];
			}
		},

		onClear() {
			this.formData = {
				deptIds: [],
				author_account: '',
				author_short_id: '',
			};
			this.talentUserIds = '';
			this.bdUserIds = '';
			this.onSubmit();
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', {
				...this.formData,
				talentUserIds: [this.talentUserIds].filter(item => item),
				bdUserIds: [this.bdUserIds].filter(item => item),
			});
		}, 1000),
	},
};
</script>
<style lang="less" scoped></style>
